module.exports = __webpack_public_path__ + "static/media/luminous-BG_top-right.2d3698f5.svg";